import React from 'react';
import { ContentFilterProvider } from '@components/ContentFilters/ContentFilterProvider';
import { useParams } from 'react-router-dom';
import { usePageTitle } from '@utils/hooks/usePageTitle';
import MainContent from '@containers/MainContent';
import CourseSelect from '@containers/CourseSelect';
import SectionSelect from '@containers/SectionSelect';
import history from '@utils/history';
import { useSelector } from 'react-redux';
import { selectors as UserSelectors } from '@reducers/user';
import QuestionGenerationService from './QuestionGenerationService';

const QGSMain = () => {
  usePageTitle('Coauthor');
  const { courseId, sectionId } = useParams();

  // ensure only teachers can access this component
  const currentUser = useSelector(UserSelectors.getCurrentUser);
  if (!(currentUser?.role.toLowerCase() === 'teacher')) {
    history.push('/dashboard');
    return null;
  }

  // If no sectionId, show a simplified view with just the section selector
  if (!courseId || !sectionId) {
    return (
      <MainContent>
        <CourseSelect pathName="/coauthor/course" />
        {courseId && <SectionSelect pathName="/coauthor/course" />}
      </MainContent>
    );
  }

  // if user declines the disclaimer, redirect to dashboard
  // they can get reprompted on revisiting the page
  const handleDisclaimerReject = () => {
    history.push('/dashboard');
  };

  return (
    <ContentFilterProvider>
      <QuestionGenerationService onDisclaimerReject={handleDisclaimerReject} />
    </ContentFilterProvider>
  );
};

export default QGSMain;
